import { ComponentProps } from "react";
import "./index.scss";

interface ActionButtonProps extends ComponentProps<"button"> {
  icon?: React.ReactNode;
  label: string;
  textColor?: string;
  hideLabelOnMobile?: boolean;
}

export const ActionButton = ({
  icon,
  label,
  textColor,
  style,
  className,
  hideLabelOnMobile = false,
  ...props
}: ActionButtonProps) => {
  const extraClassNames = [className];

  if (textColor) {
    extraClassNames.push("action-button-custom-color");
  }

  if (hideLabelOnMobile) {
    extraClassNames.push("action-button-hide-label-mobile");
  }

  const buttonClassName = extraClassNames.filter(Boolean).join(" ");

  const buttonStyle = textColor
    ? ({ ...style, "--custom-text-color": textColor } as React.CSSProperties)
    : style;

  return (
    <button
      id="action-button"
      className={`btn btn-sm text-muted p-0 ${buttonClassName}`}
      title="Salvar"
      style={buttonStyle}
      {...props}
    >
      {icon && <span className="action-button-icon">{icon}</span>}
      {label && <span className="action-button-label">{label}</span>}
    </button>
  );
};
